import CircularProgress from "@mui/material/CircularProgress";

function Loader({ color }) {
  return <CircularProgress style={{ color: color || "#ffffff" }} size={20} />;
}

export default Loader;
